// Divider Block - Styled horizontal rule
class DividerBlock {
  static get toolbox() {
    return {
      title: 'Divider',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"></line></svg>'
    };
  }

  static get isReadOnlySupported() {
    return true;
  }

  constructor({ data, config, api, readOnly }) {
    this.data = {
      style: data.style || 'solid'
    };
    this.readOnly = readOnly;
    this.wrapper = null;
  }

  render() {
    this.wrapper = document.createElement('div');
    this._render();
    return this.wrapper;
  }

  _getBorderStyle(style) {
    const styles = {
      solid: 'border-solid',
      dashed: 'border-dashed',
      dotted: 'border-dotted',
      double: 'border-double border-4'
    };
    return styles[style] || styles.solid;
  }

  _render() {
    this.wrapper.innerHTML = `
      <div class="py-4" data-testid="divider-block">
        ${!this.readOnly ? `
          <select class="style-select text-xs px-2 py-1 mb-2 rounded border bg-white dark:bg-slate-800">
            <option value="solid" ${this.data.style === 'solid' ? 'selected' : ''}>Solid</option>
            <option value="dashed" ${this.data.style === 'dashed' ? 'selected' : ''}>Dashed</option>
            <option value="dotted" ${this.data.style === 'dotted' ? 'selected' : ''}>Dotted</option>
            <option value="double" ${this.data.style === 'double' ? 'selected' : ''}>Double</option>
          </select>
        ` : ''}
        <hr class="border-t border-slate-300 dark:border-slate-600 ${this._getBorderStyle(this.data.style)}" />
      </div>
    `;

    if (!this.readOnly) {
      this.wrapper.querySelector('.style-select')?.addEventListener('change', (e) => {
        this.data.style = e.target.value;
        this._render();
      });
    }
  }

  save() {
    return this.data;
  }
}

export default DividerBlock;
